import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { IWarehouse } from '../model/warehouse.model';
import { IWarehouseResponse } from '../model/warehouse.model';

export type EntityArrayResponseType = HttpResponse<IWarehouseResponse>;
export type EntityResponseType = HttpResponse<IWarehouse>;

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {
  private apiWsWarehouse = `${environment.wsApiBaseUrl}/api/warehouse`
  protected readonly http = inject(HttpClient);

  findByCode(code: string): Observable<EntityResponseType> {
    return this.http.get<IWarehouse>(`${this.apiWsWarehouse}`, { observe: 'response', params: { code: code } });
  }

  findByCustomerAn(an: number): Observable<EntityArrayResponseType> {
    return this.http.get<IWarehouseResponse>(`${this.apiWsWarehouse}`, { observe: 'response', params: { customer_an: an } });
  }
  findByUserId(userId: number): Observable<EntityResponseType> {
    return this.http.get<IWarehouse>(`${this.apiWsWarehouse}`, { observe: 'response', params: { userId: userId } });
  }
}